export default __webpack_public_path__ + "static/media/iPadSS7.3ee958c8.png";